__turbopack_context__.v({
  "container": "NotFound-module-scss-module__vohP2q__container",
  "copy": "NotFound-module-scss-module__vohP2q__copy",
  "headline": "NotFound-module-scss-module__vohP2q__headline",
  "imageWrapper": "NotFound-module-scss-module__vohP2q__imageWrapper",
});
